import { axios, handleError } from '../axios';

export const initial = () => {
  return new Promise((resolve) => {
    axios
      .get('initial')
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
